import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class Event extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="events-area pd-top-110 pd-bottom-120 go-top">
			  <div className="container">
			    <div className="row justify-content-center">
			      <div className="col-xl-6 col-lg-7 col-md-11">
			        <div className="section-title text-center">
			        </div><br/><br/>
			      </div>
			    </div>
			    <div className="row justify-content-center">
			      <div className="col-lg-8">
			        <ul className="single-blog-list-wrap style-white" style={{backgroundColor: 'var(--heading-color)'}}>
			          <li>
			            <div className="media single-blog-list-inner style-white">
			              <div className="media-body details">
			          		<h2 className="title clrWhite">Emblem & Motto</h2>
			                <p className="clrWhite">The emblem of the college is a graphic representation of the power of the college.  With the knowledge and / or education, one’s potential or ability to succeed in the pursuit of one’s objectives will certainly increase.</p>
			              	<br/>
							<h6 className="clrWhite">Motto – “Knowledge is Power”</h6>
						  </div>
			            </div>
			          </li>
			        </ul>
			      </div>
			      <div className="col-lg-4 align-self-center">
			        <div className="event-thumb about-logo">
						<center>
							<img src={publicUrl+"assets/img/website/miet-logo.jpg"} alt="img" />
						</center>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default Event